<router-outlet></router-outlet>
<app-alert></app-alert>
<app-spinner></app-spinner>
<ng-template #SessionExpiryPopup>
    <div class="sessionCheckModal">
        <div class="sessionExpiryContent">
            Your MyLion session will end in {{ minutes }} minute(s) and
            {{ seconds }} seconds.
        </div>
        <div class="sessionAlertMessage">
            Click Continue to keep the MyLion session open, otherwise Click Exit to Logout.
        </div>
        <div class="buttons">
            <button class="exit-button" (click)="exitSession()">Exit</button>
            <button class="continue-button" (click)="continueSession()">Continue</button>
        </div>
    </div>
</ng-template>